import React from 'react';
import {Button, Icon, Table, Form, Header, Popup, Segment, Loader, Grid} from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { Redirect } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import {fetchAcademicYears, fetchStudyCycle} from '../../Lookups/util';

import { IconHeader, FiltersOnStyle, HeaderCursor } from '../../Professor/ProfessorInputGrades/css';

import SearchTableData from "../../util/SearchTableData";
import PaginationFront from '../../util/PaginationFront';
import ReactExport from 'react-data-export';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const obj = {};
const fetchStudyPrograms = () => axios.post('study-programs/filter', { ...obj });

const NoDataMessage = () => <p>Nema studenata.</p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class WithdrawalStudents extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            academicYears: [],
            academicYearsClear: [],
            academicYear: '',
            studyPrograms: [],
            studyCycles: [],
            studyCycleId: null,
            studyProgramBasics: [],
            studyProgramBasicId: null,
            studyProgramBasicsAll: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            isLoading: false,
            results: [],
            excelData: [],
            loaded: null,

            unsa: !!((localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu')),


        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.filter = this.filter.bind(this);
    }

    componentDidMount() {

        axios.post(this.state.unsa ? 'study-programs/basic/all' : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.unsa ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                console.log('studyProgramBasics', studyProgramBasics);

                this.setState({ studyProgramBasics, studyProgramBasicsAll: studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });

        axios.all([fetchAcademicYears(), fetchStudyCycle(),])
            .then(axios.spread((academicYearsRes, studyCycleRes) => {
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));
                this.setState({
                    academicYears, studyCycles
                });
            }))
            .catch(err => {
                console.log('Failed to fetch academic years or study programs');
            });
    }

    handleInputChange(event, { name, value }) {

        if (name === 'studyCycleId') {
            if (value === null) this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll });
            this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll.filter(el => el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].id === value : null) });
        }

        if (name === 'studyCycleId' && value === '') { this.setState({ studyCycleId: null, studyProgramBasics: this.state.studyProgramBasicsAll }); }

        this.setState({
            [name]: value || null
        } );
    }


    filter() {
        this.setState({ loaded: false, results: [], activePage: 1 });
        let obj = {};
        if(this.state.studyCycleId) obj = {...obj, studyCycleId: this.state.studyCycleId};
        if(this.state.studyProgramBasicId) obj = {...obj, studyProgramBasicId: this.state.studyProgramBasicId};

        if(this.state.unsa){
            axios.post(`reports/dropped-out-students-count/${this.state.academicYear ? this.state.academicYear : -1 }/`, { ...obj })
                .then(res => {

                    this.setState({ data: res.data, loaded: true,
                        excelData: res.data.map(el => ([
                        { value: el.organizationalUnitName },
                        { value: el.numberOfStudents},
                    ]))
                })})
                .catch(err => {
                    console.log('Failed to fetch students');
                });
        }
        else{
            axios.post( `students/filter/dropped-out/${this.state.academicYear ? this.state.academicYear : -1 }`, { ...obj })
                .then(res => {
                    const data = res.data.map( el=> ({
                        ...el,
                        department: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName : '',
                        dateEnrolledFormated: el.dateEnrolled ? moment(el.dateEnrolled).format('D. M. YYYY.') : '',
                        dateOfAbandonmentFormated: el.dateOfAbandonment ? moment(el.dateOfAbandonment).format('D. M. YYYY.') : ''
                    }));
                    this.setState({ data, loaded: true });
                    const excelData = res.data.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.studyCycleName},
                        { value: el.dateEnrolled ? moment(el.dateEnrolled).format('D. M. YYYY.') : ''},
                        { value: el.dateOfAbandonment ? moment(el.dateOfAbandonment).format('D. M. YYYY.') : ''},
                    ]));
                    this.setState({excelData: excelData});
                })
        }
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        // this.setState({ results });
        if(results.length === 0)
        {
            this.setState({
                excelData:  this.state.unsa ?
                    this.state.data.map(el => ([
                        { value: el.organizationalUnitName },
                        { value: el.numberOfStudents},
                    ]))
                    : this.state.data.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.studyCycleName},
                        { value: el.dateEnrolled ? moment(el.dateEnrolled).format('D. M. YYYY.') : ''},
                        { value: el.dateOfAbandonment ? moment(el.dateOfAbandonment).format('D. M. YYYY.') : ''},
                    ]))});
        }
        else {
            this.setState({ results,
                excelData:  this.state.unsa ?
                    results.map(el => ([
                        { value: el.organizationalUnitName },
                        { value: el.numberOfStudents},
                    ]))
                    : results.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.studyCycleName},
                        { value: el.dateEnrolled ? moment(el.dateEnrolled).format('D. M. YYYY.') : ''},
                        { value: el.dateOfAbandonment ? moment(el.dateOfAbandonment).format('D. M. YYYY.') : ''},
                    ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})

    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    render() {

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 200 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'Plan i program', width: { wpx: 300 } },
                    { title: 'Ciklus studija', width: { wpx: 200 } },
                    { title: 'Datum upisa', width: { wpx: 200 } },
                    { title: 'Datum ispisa', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];

        const multiDataSet1 = [
            {
                columns: [
                    { title: 'Organizaciona jedinica', width: { wpx: 150 } },
                    { title: 'Broj studenata', width: { wpx: 150 } },
                ],
                data: this.state.excelData,
            }
        ];

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);


        return (
            <div>
                <Form>
                    {/*{this.state.unsa && <Form.Group widths="equal">*/}
                    {/*    <Form.Field>*/}
                    {/*        <Form.Dropdown*/}
                    {/*            clearable*/}
                    {/*            label="Organizaciona jedinica"*/}
                    {/*            placeholder="Organizaciona jedinica"*/}
                    {/*            value={this.state.organizationalUnitId}*/}
                    {/*            onChange={this.handleInputChange}*/}
                    {/*            name="organizationalUnitId"*/}
                    {/*            options={this.props.organizationalUnits}*/}
                    {/*            search*/}
                    {/*            fluid*/}
                    {/*            required*/}
                    {/*            selection*/}
                    {/*            error={this.state.organizationalUnitEntityError}*/}
                    {/*        />*/}
                    {/*    </Form.Field>*/}
                    {/*    <Form.Field />*/}
                    {/*    <Form.Field />*/}
                    {/*</Form.Group>}*/}
                    {/*{!this.state.unsa &&<br />}*/}
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYear}
                                onChange={this.handleInputChange}
                                name="academicYear"
                                options={this.state.academicYears}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <Form.Dropdown
                                label="Ciklus studija"
                                clearable
                                placeholder="Odaberite ciklus"
                                options={this.state.studyCycles}
                                onChange={this.handleInputChange}
                                name="studyCycleId"
                                value={this.state.studyCycleId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <Form.Dropdown
                                label="Studijski program"
                                clearable
                                placeholder="Odaberite studijski program"
                                options={this.state.studyProgramBasics}
                                onChange={this.handleInputChange}
                                name="studyProgramBasicId"
                                value={this.state.studyProgramBasicId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                    </Form.Group>

                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button color="blue" floated="right" onClick={this.filter}>Filtriraj
                    </Button>
                </Form>

                <br /><br /><br />
                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    this.state.loaded &&
                    <div>

                        {this.state.data.length ?
                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={this.state.unsa ? 2 : 14} >
                                    <Grid columns={2} stackable>

                                        <Grid.Column width={14}>
                                            <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['organizationalUnitName', 'firstName', 'lastName', 'studyProgramName', 'studyProgramBasicName', 'dateEnrolledFormated', 'dateOfAbandonmentFormated', 'department', 'studyCycleName']} />
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign={'center'}>
                                            <ExcelFile filename="Spisak ispisanih studenata" element={<Popup
                                                trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                    <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                    <Button.Content visible>
                                                        Excel
                                                    </Button.Content>
                                                </Button>}
                                                content="Preuzmi spisak u Excel-u"
                                                hideOnScroll
                                                position="top center"
                                            />}>
                                                <ExcelSheet dataSet={this.state.unsa ? multiDataSet1 : multiDataSet} name="Studenti" />
                                            </ExcelFile>
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                            </Table.Row>
                            {this.state.unsa ? <Table.Row>
                                    <Table.HeaderCell >Organizaciona jedinica</Table.HeaderCell>
                                    <Table.HeaderCell >Broj studenata</Table.HeaderCell>
                                </Table.Row>
                                : <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Prezime i ime</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Odsjek</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Studijski program</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Ciklus studija</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Datum upisa</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Datum ispisa</Table.HeaderCell>
                            </Table.Row>}
                        </Table.Header>
                        {this.state.unsa ?
                            <Table.Body> {currentPosts.map((el, index) =>
                                (<Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle">
                                            {el.organizationalUnitName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.numberOfStudents}
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                           : <Table.Body> {currentPosts.map((el, index) =>
                            (<Table.Row key={index}>
                                    <Table.Cell verticalAlign="middle">
                                        {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.lastName} {el.firstName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.departmentsSPOU.map(e => <div>{e.organizationalUnitName}</div>)}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.studyCycleName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.dateEnrolledFormated}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.dateOfAbandonmentFormated}
                                    </Table.Cell >
                                </Table.Row>

                            ))}
                        </Table.Body>}
                    </Table>
                        : <NoDataMessage />
                }

                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                <ToastContainer hideProgressBar />
                    </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/WithdrawalStudents.js